import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import Button from '../../../common/Button/Button';
import UpdateInvoiceModal from '../Modals/UpdateInvoiceModal';
import UploadFile from '../../../common/Upload/UploadFile';
import { useContext, useEffect, useState } from 'react';
import { UPLOAD_INVOICE_BATCH_UPDATES } from '../../../../constants/ApiConstants';
import CreatePayoutModal from '../Modals/CreatePatoutModal';
import { AppFactsContext } from '../../../common/Navigation/Navigation';

export default function InvoiceActions({
  openUpdateModal,
  setUpdateModalOpen,
  setCreatePayoutModalOpen,
  createPayoutModalOpen,
  onOk,
  n,
  count,
  nullInvoicePeriodCount,
  selectedRecords,
  handleCreatePayout,
}) {
  const [uploadModel, setUploadModel] = useState({
    open: false,
    key: 1,
    type: '',
    url: '',
  });

  const [isCreatePayoutDisable, setIsCreatePayoutDisable] = useState(false);
  const [isUpdateDisable, setisUpdateDisable] = useState(false);
  const { appFacts } = useContext(AppFactsContext);

  useEffect(() => {
    const { generate_payouts, update_invoices } = appFacts;
    if (generate_payouts !== undefined) {
      setIsCreatePayoutDisable(generate_payouts);
    }
    if (update_invoices !== undefined) {
      setisUpdateDisable(update_invoices);
    }
  }, [appFacts?.generate_payouts, appFacts?.update_invoices]);

  const handleShowUploadModal = (type) => {
    setUploadModel({
      open: true,
      key: uploadModel.key + 1,
      type: 'Update',
      url: type === 'Upload Batch Updates' ? UPLOAD_INVOICE_BATCH_UPDATES : '',
    });
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ gap: 16, display: 'flex' }}>
          <Button
            onClick={() => setCreatePayoutModalOpen(true)}
            disabled={isCreatePayoutDisable}
          >
            <PlusOutlined />
            Create Payouts
          </Button>
          <Button
            onClick={() => handleShowUploadModal('Upload Batch Updates')}
            variant="outlined"
            type="default"
            disabled={isUpdateDisable}
          >
            <UploadOutlined />
            Upload Batch Update
          </Button>
        </div>

        <UpdateInvoiceModal
          n={n}
          onOk={onOk}
          open={openUpdateModal}
          selectedRecords={selectedRecords}
          nullInvoicePeriodCount={nullInvoicePeriodCount}
          setOpen={setUpdateModalOpen}
          count={count}
        />
        <CreatePayoutModal
          n={n}
          onOk={onOk}
          open={createPayoutModalOpen}
          setOpen={setCreatePayoutModalOpen}
          disabled={isCreatePayoutDisable}
          count={count}
          selectedRecords={selectedRecords}
          handleCreatePayout={handleCreatePayout}
        />
        <UploadFile
          key={uploadModel.key}
          visible={uploadModel.open}
          type={uploadModel.type}
          onClose={() => setUploadModel(false)}
          url={uploadModel.url}
        />
      </div>
    </>
  );
}
